import { config } from '@components/Portfolio/config'
import { getSlidersForSuccessSections } from '@helpers/getSlidersForSuccessSections'

export const configuration = {
  title: 'Success stories',
  subtitle:
    'Over the years of cooperation with businesses from 25+ industries, our team has acquired wide and varied experience that allows us to build top-notch software products that are destined to succeed.',
  config: getSlidersForSuccessSections(config.listValues, [
    '21',
    '24',
    '39',
    '16',
    '48',
  ]),
  padding: '2%',
}
